export default __webpack_public_path__ + "static/media/tag_paid-coin-laundry.048b62f0.svg";